var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    _vm.variant === 'text' && {
      'border-none bg-lighter-grey-2 text-regular-grey fill-regular-grey !cursor-default': _vm.disabled,
      'shadow-button-pressed bg-primary-00 text-primary-10 fill-primary-10 border-primary-10': !_vm.disabled && _vm.active,
      '[&>svg-icon:w-24px] hover:text-primary-10 hover:fill-primary-10 active:shadow-active-button  cursor-pointer':
        !_vm.disabled,
      'text-soft-grey fill-inactive border-none bg-transparent': !_vm.disabled && !_vm.active,
    },
    _vm.variant === 'outlined' && {
      'shadow-button-pressed bg-primary-0 text-primary-10 fill-primary-10 border-primary-10': !_vm.disabled && _vm.active,
      'text-soft-grey fill-inactive border-regular-grey hover:border-primary-10 bg-white': !_vm.disabled && !_vm.active,
      'border-grey-2 !bg-gray-1 text-regular-grey fill-regular-grey !cursor-not-allowed': _vm.disabled,
      '[&>svg-icon:w-24px] hover:text-primary-10 hover:fill-primary-10 active:fill-primary-10 hover:border-primary-10 active:shadow-active-button] active:bg-primary-0 focus:border-primary-4 focus:outline-[3px] focus:outline focus:outline-primary-4  cursor-pointer':
        !_vm.disabled,
    },
    _vm.variant === 'filled' && {
      '!border-none': true,
      '[&>svg-icon:w-24px] focus:outline-[3px] focus:outline  cursor-pointer': !_vm.disabled,
      'text-white bg-primary-10 hover:bg-primary-8 fill-white focus:outline-primary-4':
        _vm.color === 'primary' && !_vm.disabled,
      'text-white bg-papaya-10 hover:bg-papaya-8 focus:outline-papaya-6': _vm.color === 'papaya',
      'border-grey-2 !bg-gray-1 text-regular-grey fill-regular-grey !cursor-not-allowed': _vm.disabled,
      'text-gray-6 bg-pear-2 hover:bg-pear-6 focus:outline-pear-6 ': _vm.color === 'pear',
    },
    {
      'w-full text-center justify-center': _vm.fit,
      'rounded-20': _vm.rounded,
      'rounded-8': !_vm.rounded,
      'h-40px py-8px text-18 font-600 px-24px': _vm.size === 40,
      'h-32px py-6px text-16 font-600': _vm.size === 32,
      'active:shadow-button-pressed focus-visible:shadow-focus': !_vm.disabled,
    },
    'custom-button border-solid border-1 flex items-center px-16px user-select-none text-16',
    _vm.buttonClass,
  ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.onEnterKeyup.apply(null, arguments)}}},[(_vm.loading)?_c('BaseIconSVG',{staticClass:"mr-8px animate-spin",attrs:{"name":"loading-static"}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }